<template>
  <section>
    <el-col
      v-if="buttonList != null && buttonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-input
            v-model="filters.DeptName"
            placeholder="部门名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.PhoneNumber"
            placeholder="手机号码"
          ></el-input>
        </el-form-item>
        <el-form-item v-for="item in buttonList" v-bind:key="item.id">
          <el-button
            v-prevent-re-click
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="tabData"
      border=""
      v-loading="listLoading"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      ref="table"
      style="width: 100%"
      class="custom-tbl"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column
        prop="DeptName"
        label="所属部门"
        width="200"
      ></el-table-column>
      <el-table-column
        prop="PhoneNumber"
        label="手机号码"
        width="140"
      ></el-table-column>
      <el-table-column
        prop="ParticipantTypeName"
        label="账号类型"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        width="180"
      ></el-table-column>
      <el-table-column prop="" label="已录入/录入上限" width="180">
        <template slot-scope="scope">
          {{ scope.row.ExistNumber }} / {{ scope.row.UpperLimit }}
        </template>
      </el-table-column>
      <el-table-column
        prop="ActivityName"
        label="活动名称"
        show-overflow-tooltip
      >
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.PageIndex"
        :page-size="filters.PageSize"
        :total="filters.total"
        style="float: right"
      ></el-pagination>
    </el-col>

    <!-- 新增客户用户 -->
    <el-dialog
      title="新增客户用户"
      :visible.sync="addFormVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
      >
        <el-form-item prop="PidArr" label="所属部门名称">
          <el-cascader
            ref="cascader"
            placeholder="请选择，支持搜索功能"
            v-model="ruleForm.PidArr"
            clearable
            :options="options"
            filterable
            @change="handleChange"
            :props="{ checkStrictly: true, expandTrigger: 'hover' }"
            v-if="!editLoading"
          ></el-cascader>
          <el-cascader
            placeholder="加载中..."
            style="width: 400px"
            v-if="editLoading"
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="UserId" label="关联用户">
          <el-select v-model="ruleForm.UserId" placeholder="请选择关联用户">
            <el-option
              v-for="item in userList"
              :key="item.UserId"
              :label="item.LoginName"
              :value="item.UserId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="UpperLimit" label="录入人员上限">
          <el-input
            placeholder="录入人员上限"
            v-model.number="ruleForm.UpperLimit"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="ParticipantTypeIds" label="可录入参会类别">
          <el-checkbox-group
            v-model="ruleForm.ParticipantTypeIds"
            @change="handleCheck"
          >
            <el-checkbox
              v-for="item in cateTypes"
              :label="item.Id"
              :key="item.Id"
              >{{ item.Name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item prop="ActivityId" label="适用活动">
          <el-select
            v-model="ruleForm.ActivityId"
            placeholder="请输入关键词"
            :loading="loadingActivityName"
            filterable
            remote
            reserve-keyword
            :remote-method="remoteMethod"
            @change="handleActName"
          >
            <el-option
              v-for="item in activityList"
              :key="item.ActivityId"
              :label="item.ActivityName"
              :value="item.ActivityId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >提 交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </section>
</template>

<script>
import {
  getDepartmentTree,
  getUserListByDepId,
  getDeptActivityList,
  getParticipantTypeList,
  getActivityList,
  addOrUpdDeptActivity,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'

export default {
  data() {
    return {
      listLoading: false,
      buttonList: [],
      options: [], // 部门联级
      editLoading: false,
      userList: [], // 关联用户
      filters: {
        DeptName: '',
        PhoneNumber: '',
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      tabData: [], // 列表绑定数据
      addFormVisible: false, // 新增弹框
      cateTypes: [], // 可录入参会类别

      activityList: [], // 适用活动
      loadingActivityName: false, // 适用活动 加载效果
      // 新增弹窗数据
      ruleForm: {
        DepartmentId: '',
        PidArr: [],
        UserId: '',
        UpperLimit: '',
        ParticipantTypeIds: [],
        ActivityId: '',
        ActivityName: '',
      },
      rules: {
        PidArr: [
          { required: true, message: '请选择所属部门名称', trigger: 'change' },
        ],
        UserId: [
          { required: true, message: '请选择关联用户', trigger: 'change' },
        ],
        PhoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          ,
          { min: 11, max: 11, message: '请输入正确的手机号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号' },
        ],
        UpperLimit: [
          { required: true, message: '请输入录入人员上限', trigger: 'blur' },
          { type: 'number', message: '人员上限必须为数字值' },
        ],
        ParticipantTypeIds: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个参会类别',
            trigger: 'change',
          },
        ],
        ActivityId: [
          { required: true, message: '请选择适用活动', trigger: 'change' },
        ],
      },
    }
  },
  components: {
    // Toolbar
  },
  methods: {
    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },

    // 下载名单
    handleDownload() {
      let row = this.currentRow
      console.log(row)
      this.options = []
      if (!row) {
        this.$message({
          message: '请选择要下载的一行数据！',
          type: 'error',
        })
        return
      }
      const token = window.localStorage.getItem('Token')
      const url = `${process.env.VUE_APP_BASE_API}/api/DeptActivity/download/${row.Id}`
      var xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      xhr.responseType = 'blob' // 返回类型blob
      xhr.setRequestHeader('Authorization', 'Bearer ' + token) // 携带token校验
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response
          var reader = new FileReader()
          reader.readAsDataURL(blob) // 转换为base64
          reader.onload = function (e) {
            var a = document.createElement('a') // 创建一个a标签用于下载
            a.download = '活动参会人.xls' //文件名
            a.href = e.target.result
            a.click()
            $(a).remove()
          }
        }
      }
      xhr.send() // 发送ajax请求
    },

    // 按钮点击事件传值
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    dialogCheck(selection, row) {
      this.currentRow = null
      this.$refs.table.clearSelection()
      if (selection.length === 0) {
        return
      }
      if (row) {
        this.selectCurrentRow(row)
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val
        this.$refs.table.clearSelection()
        this.$refs.table.toggleRowSelection(val, true)
      }
    },
    handleCurrentChange(val) {
      this.filters.PageIndex = val
      this.handleQuery()
    },
    // 新增客户用户
    handleAdd() {
      getParticipantTypeList().then((res) => {
        if (res.data.success) {
          this.cateTypes = res.data.response
        }
      })
      // 打开弹窗
      this.addFormVisible = true
      this.options = []
      getDepartmentTree(0).then((res) => {
        this.options.push(res.data.response)

        // console.log(res)
      })
    },

    // 所属部门名称 切换事件
    handleChange() {
      // console.log(e);
      const pidList = this.ruleForm.PidArr
      const length = pidList.length
      // console.log(pidList[length - 1])
      this.ruleForm.DepartmentId = pidList[length - 1]

      this.ruleForm.UserId = '' // 切换事件发生时，清空关联用户数据
      if (length > 0) {
        let para = {
          departmentId: pidList[length - 1],
        }
        getUserListByDepId(para).then((res) => {
          this.userList = res.data.response
        })
      } else {
        return false
      }
    },

    // 参会类别 change 事件
    handleCheck(val) {
      this.ruleForm.ParticipantTypeIds = val
    },

    // 适用的活动
    remoteMethod(query) {
      if (query !== '') {
        this.loadingActivityName = true
        setTimeout(() => {
          getActivityList(query).then((res) => {
            if (res.data.success) {
              this.activityList = res.data.response
              this.loadingActivityName = false
            }
          })
        }, 500)
      }
    },
    // 使用活动 选择事件，获取选择数据的值
    handleActName(val) {
      this.ruleForm.ActivityName = val
        ? this.activityList.find((ele) => ele.ActivityId === val).ActivityName
        : ''
    },
    addOrUpd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addOrUpdDeptActivity(this.ruleForm).then((res) => {
            if (res.data.success) {
              this.handleQuery()
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
              this.addFormVisible = false
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }
          })
        } else {
          return false
        }
      })
    },
    // 提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addOrUpdDeptActivity(this.ruleForm).then((res) => {
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
              this.$refs[formName].resetFields()
              this.addFormVisible = false
              this.options = []
              this.activityList = []
              this.handleQuery()
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }
          })
        } else {
          return false
        }
      })
    },

    // 查询按钮——显示数据
    handleQuery() {
      this.listLoading = true
      getDeptActivityList(this.filters).then((res) => {
        if (res.data.success) {
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.tabData = res.data.response.data
          this.listLoading = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
  },
  mounted() {
    this.handleQuery()

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    this.buttonList = getButtonList(this.$route.path, routers)
  },
}
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
